import { registerLocaleData } from '@angular/common';
import { inject } from '@angular/core';
import { LocalStorageService } from 'src/app/kernel/tools/services/local-storage.service';
import { ELocalizationLang } from 'src/app/vogo-core/enums';
import { IUser } from 'src/app/vogo-core/interfaces';

const locales: Record<ELocalizationLang, () => Promise<any>> = {
  'en': () => import('@angular/common/locales/en'),
  'ar': () => import('@angular/common/locales/ar'),
}

export const loadLocale = () => {
  const localStorage = inject(LocalStorageService);
  const loggedInUser = localStorage.get<IUser>('user');
  let lang = localStorage.get<ELocalizationLang>('lang') || ELocalizationLang.EN;
  if(!!loggedInUser?.preferredLang) {
    lang = loggedInUser.preferredLang;
    localStorage.set('lang', loggedInUser.preferredLang);
  }
  locales[lang]().then((d) => registerLocaleData(d.default));
  return lang;
}